;(function () {
  const components = {
    backToTop: SAXX.Init.Component((node) => {
      const scrollThreshold =
        parseFloat(node.getAttribute('data-scroll-threshold')) || 300

      node.classList.toggle('invisible', window.scrollY < scrollThreshold)

      window.addEventListener('scroll', () => {
        node.classList.toggle('invisible', window.scrollY < scrollThreshold)
      })

      node.addEventListener('click', (e) => {
        e.preventDefault()

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
